// extracted by mini-css-extract-plugin
export default {"servicesPage":"ServicesPage_servicesPage__r3enl","pageHeader":"ServicesPage_pageHeader__m9jAo","servicesGrid":"ServicesPage_servicesGrid__PTaDE"};